import { render, staticRenderFns } from "./addPeriod.vue?vue&type=template&id=94f8379e"
import script from "./addPeriod.vue?vue&type=script&lang=js"
export * from "./addPeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports